<script setup lang="ts">
import useVideos from "@/video/composables/useVideos";
import {Mail, MessageCircleCheck, Play, Pointer} from "@lucide/vue";
import VideoItem from "@/video/components/VideoItem.vue";
import {storeToRefs} from "pinia";
import {useCreditStore} from "@/stores/credit.store";
import BaseButton from "@/core/components/base/BaseButton.vue";
import PremiumButton from "@/rcs/components/PremiumButton.vue";
import BaseCard from "@/core/components/base/BaseCard.vue";
import BaseCardBody from "@/core/components/base/BaseCardBody.vue";
import RcsList from "@/rcs/components/RcsList.vue";

const creditStore = useCreditStore();
const {credit} = storeToRefs(creditStore);
const {data: videos} = useVideos({
    limit: 1,
    tags: ['rcs']
});
</script>

<template>
  <div class="flex flex-col gap-6">
    <div class="bg-white p-4 flex flex-col gap-4">
      <div class="flex justify-between gap-4">
        <div>
          <h1>Découvrez les SMS enrichis #RCS</h1>
          <p>Offrez une nouvelle expérience à vos patients grâce aux SMS enrichis.</p>
        </div>
        <div class="flex flex-col gap-2 items-end shrink-0">
          <div v-if="credit" class="flex items-center  text-xs">
            <p>
              Il vous reste {{ credit.balance }} SMS
            </p>
            <router-link to="/patient-administration/communication/message/store">
              <BaseButton variant="flat" density="compact" class="text-primary !text-xs px-2">
                Acheter
              </BaseButton>
            </router-link>
          </div>
          <PremiumButton />
        </div>
      </div>
      <div class="flex gap-3">
        <div
          v-for="video in (videos?.data ?? [])" :key="video.id"
          class="hover:bg-lightPurple-lightest rounded-lg transition duration-200 p-1"
        >
          <VideoItem :video="video" class="bg-[#FB0129] !text-white py-1">
            <template #icon>
              <Play class="fill-white shrink-0 size-5 ml-2" />
            </template>
          </VideoItem>
        </div>
      </div>
      <div class="flex gap-4 justify-around">
        <div class="flex items-start gap-2">
          <MessageCircleCheck class="size-6 shrink-0" />
          <p><span class="text-primary font-medium">3x plus d'impact</span> que les SMS</p>
        </div>
        <div class="flex items-start gap-2">
          <Mail class="size-6 shrink-0" />
          <p><span class="text-primary font-medium">10x plus d'impact</span> qu'un mail</p>
        </div>
        <div class="flex items-start gap-2">
          <Pointer class="size-6 shrink-0" />
          <p class="text-primary font-medium">
            Expérience visuelle et interactive
          </p>
        </div>
      </div>
    </div>
    <BaseCard class="mx-4">
      <BaseCardBody>
        <div>
          <h2>👉 Le mieux, c'est de l'essayer !</h2>
          <p>Testez vous-même, et offrez une nouvelle expérience à vos patients grâce aux SMS enrichis.</p>
        </div>
        <RcsList class="mt-4" />
      </BaseCardBody>
    </BaseCard>
  </div>
</template>

<style scoped>
:deep(.video-title) {
    @apply text-sm text-white font-medium leading-tight;
}
</style>
